import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { KpiUserAssignmentBodyModel } from '@/types'

export const postKpiUserAssignments = async (
  assignments: KpiUserAssignmentBodyModel[]
): Promise<void> => {
  try {
    await axios.post(`${BASE_URL}/kpi/user-assignments/`, assignments)
  } catch (error) {
    console.error('Error posting KPI user assignments:', error)
    throw error
  }
}
